import { NavLink } from "react-router-dom";

import SectionLabel from "../../../app/universalComponents/SectionLabel";
import StatusIndicator from "../../../app/universalComponents/StatusIndicator";
import Placeholder from "../../../assets/images/placeholderPoster.png";
import ErrorState from "../../../app/universalComponents/ErrorState";

import { formatStatus } from "../../../app/utils/formatting";

export default function EventsNav({ eventsList }) {
  if (!eventsList || eventsList.length === 0) {
    return (
      <nav className="flex min-h-0 flex-1 flex-col p-4">
        <SectionLabel>My Events</SectionLabel>
        <ErrorState>You'll be able to navigate your future events on this list.</ErrorState>
      </nav>
    );
  }

  return (
    <nav className="flex min-h-0 flex-1 flex-col p-4">
      <SectionLabel>My Events</SectionLabel>

      <ul className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto">
        {eventsList.map((event) => (
          <li key={event.id}>
            <NavLink
              to={`/dashboard/${event.slug}`}
              className={({ isActive }) => `flex w-full min-w-0 gap-2 rounded-sm text-left hover:bg-gray-100 ${isActive ? "border-r-4 border-black" : ""}`}
            >
              <img src={event.poster || Placeholder} alt={event.title} className="aspect-square h-auto w-14 shrink-0 rounded-sm object-cover" />

              <div className="min-w-0 p-2">
                <p className="truncate text-sm font-semibold">{event.title}</p>
                <p className="truncate text-xs">{event.date}</p>

                <StatusIndicator tone={event.status}>
                  {formatStatus(event.status)}
                </StatusIndicator>
              </div>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}